export default __webpack_public_path__ + "static/media/avatar.bf28321f.png";